export enum PusherChannel {
  USER = 'private-user',
  COURSE = 'private-course',
  COURSE_TEAM = 'private-courseTeam',
}

export enum PusherEventName {
  POLL_SUBMITTED = 'pollSubmitted',
  ATTENDANCE_MARKED = 'attendanceMarked',
  WEB_ATTENDANCE_WARNING = 'web-attendanceWarning',
}

export interface CreatePusherEventOptions {
  /**
   * Used to show in-app or desktop notifications
   * @default true
   */
  notify?: boolean;
  /** List of channels that can receive this event */
  channels: PusherChannel[];
  /**
   * Ignore pusher events if user-id of sender is equal
   * to current user's id
   * @default true
   */
  ignoreForSameUser?: boolean;
}

export interface PusherEventMetaData {
  /** channel which received this event */
  receivedOn: PusherChannel;
  eventName: PusherEventName;
  /** Used to show in-app or desktop notifications */
  notify: boolean;
  /**
   * Ignore pusher events if user-id of sender is equal
   * to current user's id
   * @default true
   */
  ignoreForSameUser: boolean;
}

export interface PusherEvent<P extends {}, T extends PusherEventName = PusherEventName> {
  type: T;
  payload: P;
  meta: PusherEventMetaData;
}

export interface PusherEventCreator<P extends {}, T extends PusherEventName> {
  eventName: T;
  /** List of channels that can receive this event */
  channels: PusherChannel[];
  (payload: P, channel: PusherChannel): PusherEvent<P, T>;
  match(event: PusherEvent<any>): event is PusherEvent<P, T>;
}

export interface BasePusherEventPayload {
  /** could be "NA" in some cases */
  msgId: string;
  /** @deprecated - not used in ppt addon */
  goToView?: unknown;
  message?: string;
  /** unix-timestamp, added after receiving event at client side */
  timestamp: UnixTime;
  /** @deprecated - not used in ppt addon */
  sender: unknown;
}

export type PusherEventPayload<T extends {} = never> = [T] extends [never]
  ? BasePusherEventPayload
  : T extends { sender: any }
    ? Omit<BasePusherEventPayload, 'sender'> & T
    : BasePusherEventPayload & T;

export interface PusherSubscriptionError {
  /** Category of error that occured, e.g. AuthError */
  type: string;
  /** The HTTP Status code of the error response from the auth call. */
  status: number;
  /** Human readable details of error that occurred. */
  error: string;
}
